import createHasSubmitSucceeded from './selectors/hasSubmitSucceeded';
import plain from './structure/plain';

export default createHasSubmitSucceeded(plain);


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/redux-form@6.8.0_btckld2a72haxcqt7vtk4t56yu/~/redux-form/es/hasSubmitSucceeded.js
// module id = 651
// module chunks = 0